import {
  SET_IMPORT_DIALOG,
  SET_LOADING,
  FETCH_COURSE_LOG,
  SET_COURSE_LOG,
  LOG_COURSE_LOG,
  SET_ACTIVE_PROGRAM
} from './constants';

// const BASE_URL = 'http://localhost:3000';
const BASE_URL = 'https://program-helper.herokuapp.com';

export const actions = {
  [SET_IMPORT_DIALOG]({ commit }, payload) {
    commit(SET_IMPORT_DIALOG, payload);
  },
  [SET_LOADING]({ commit }, payload) {
    commit(SET_LOADING, payload);
  },
  async [FETCH_COURSE_LOG]({ dispatch }, payload) {
    dispatch(SET_LOADING, true);
    try {
      const data = await fetch(`${BASE_URL}/course_log?ACIXSTORE=${payload}`).then(r => r.json());
      dispatch(SET_COURSE_LOG, data);
      return true;
    } catch (error) {
      return false;
    } finally {
      dispatch(SET_LOADING, false);
    }
  },
  [SET_COURSE_LOG]({ commit, getters }, payload) {
    commit(SET_COURSE_LOG, payload);
    commit(SET_ACTIVE_PROGRAM, getters.menus[0].name);
  },
  async [LOG_COURSE_LOG]({ dispatch }, payload) {
    dispatch(SET_LOADING, true);
    const body = {
      type: 'manual',
      no: payload.map(v => v.semester + v.no),
      grade: payload.map(v => v.grade),
    };
    await fetch(`${BASE_URL}/log_course_log`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body),
    });
    dispatch(SET_COURSE_LOG, payload);
    dispatch(SET_LOADING, false);
  },
  [SET_ACTIVE_PROGRAM]({ commit }, payload) {
    commit(SET_ACTIVE_PROGRAM, payload);
  },
};